import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RadiantHorizon from './components/RadiantHorizon.jsx';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<RadiantHorizon />} />
      </Routes>
    </BrowserRouter>
  );
}
